import * as React from "react";

export default ({ color = '#A3B2C9', size = 12 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="6" cy="6" r="6" fill={color}/>
    <path
      d="M3.5 6.75C3.69891 6.75 3.88968 6.67098 4.03033 6.53033C4.17098 6.38968 4.25 6.19891 4.25 6C4.25 5.80109 4.17098 5.61032 4.03033 5.46967C3.88968 5.32902 3.69891 5.25 3.5 5.25C3.30109 5.25 3.11032 5.32902 2.96967 5.46967C2.82902 5.61032 2.75 5.80109 2.75 6C2.75 6.19891 2.82902 6.38968 2.96967 6.53033C3.11032 6.67098 3.30109 6.75 3.5 6.75Z"
      fill="white"
    />
    <path
      d="M6 6.75C6.19891 6.75 6.38968 6.67098 6.53033 6.53033C6.67098 6.38968 6.75 6.19891 6.75 6C6.75 5.80109 6.67098 5.61032 6.53033 5.46967C6.38968 5.32902 6.19891 5.25 6 5.25C5.80109 5.25 5.61032 5.32902 5.46967 5.46967C5.32902 5.61032 5.25 5.80109 5.25 6C5.25 6.19891 5.32902 6.38968 5.46967 6.53033C5.61032 6.67098 5.80109 6.75 6 6.75Z"
      fill="white"
    />
    <path
      d="M8.5 6.75C8.69891 6.75 8.88968 6.67098 9.03033 6.53033C9.17098 6.38968 9.25 6.19891 9.25 6C9.25 5.80109 9.17098 5.61032 9.03033 5.46967C8.88968 5.32902 8.69891 5.25 8.5 5.25C8.30109 5.25 8.11032 5.32902 7.96967 5.46967C7.82902 5.61032 7.75 5.80109 7.75 6C7.75 6.19891 7.82902 6.38968 7.96967 6.53033C8.11032 6.67098 8.30109 6.75 8.5 6.75Z"
      fill="white"
    />
  </svg>
);
